var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled, { keyframes } from "styled-components";
var flashing = function () { return keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n 0%,\n 100% {\n    opacity: 0;\n  }\n\n  50% {\n    opacity: 1;\n  }\n}"], ["\n 0%,\n 100% {\n    opacity: 0;\n  }\n\n  50% {\n    opacity: 1;\n  }\n}"]))); };
var Dots = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline-flex;\n"], ["\n  display: inline-flex;\n"])));
var Dot = styled.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  animation: ", " 2s ease-in-out infinite;\n  animation-delay: ", "s;\n  display: inline;\n"], ["\n  animation: ", " 2s ease-in-out infinite;\n  animation-delay: ", "s;\n  display: inline;\n"])), flashing, function (props) { return props.delay; });
export var LoadingText = function (_a) {
    var text = _a.text, children = _a.children;
    return (_jsxs("span", { children: [text || children, _jsx(Dots, { children: [0.3, 0.6, 0.9].map(function (value) { return (_jsx(Dot, __assign({ delay: value }, { children: "." }), value)); }) }, void 0)] }, void 0));
};
var useLoadingText = function (text) {
    if (text === void 0) { text = "Loading"; }
    return _jsx(LoadingText, { text: text.toUpperCase() }, void 0);
};
export default useLoadingText;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=useLoadingText.js.map